import { useMemo } from "react";
import { useDrag } from "react-dnd";
import OpenShifts from "./OpenShifts";
import Unavailable from "./Unavailable";
import DailyInfo from "./DailyInfo";
import Shift from "./Shift";
import { useScheduleContext } from "../../../../../hooks/context/useScheduleContext";
import { usePermissions } from "../../../../../hooks/usePermissions";

function Items({ type, event, day }: any) {
    const { dailyInfo } = useScheduleContext();
    const { canCreate, canEdit } = usePermissions();

    const [{ }, drag] = useDrag(() => ({
        type: "calendar-event",
        item: { ...event, user: event?.user?.id || event?.user } as any,
        canDrag: (type === "shift" || type === "unassigned" || type === undefined) && (canCreate || canEdit) && !event?.locked,
        collect: (monitor) => ({ isDragging: !!monitor.isDragging() }),
    }), [event]) as any;

    const content = useMemo(() => {
        switch (type) {
            case "open-shift":
            case "offer-shifts":
            case "call-off":
            case "direct-offer":
                return <OpenShifts event={event} />;
            case "unavailable":
                return <Unavailable event={event} day={day} />;
            case "daily-info": {
                if (dailyInfo) {
                    return <DailyInfo event={event} />;
                }
                return null;
            }
            default:
                return <Shift event={{ ...event, type }} />;
        }
    }, [day, event, type, dailyInfo]);

    const ref = useMemo(() => {
        switch (type) {
            case "open-shifts":
            case "daily-info":
            case "unavailable":
                return null;
            default:
                return drag;
        }
    }, [type, drag]);

    return (
        <div ref={ref} key={event.id} className="tw-bg-transparent">
            {content}
        </div>
    );
}

export default Items;
